var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99995 14.9283C6.74825 14.892 6.49789 14.8418 6.25003 14.7778C6.15565 14.7534 6.06163 14.7271 5.96802 14.6987C4.41827 14.2286 3.07946 13.2356 2.17972 11.8891C1.27999 10.5425 0.874982 8.92565 1.03372 7.31396C1.13419 6.29392 1.45653 5.31589 1.97001 4.44493C2.09928 4.22565 2.24067 4.01317 2.39368 3.80852L2.43856 3.85336C1.6878 4.86025 1.22054 6.05771 1.0962 7.32011C0.93889 8.91735 1.34026 10.5197 2.23193 11.8542C3.1236 13.1887 4.45039 14.1727 5.98625 14.6386C6.31972 14.7397 6.65859 14.8151 6.99995 14.8648L6.99995 14.9283ZM6.99995 14.9283C7.33184 14.9762 7.66605 15.0001 7.99996 15.0001L7.99991 14.1385",
    fill: "white",
    stroke: "url(#paint0_linear_1993_5227)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.9282V14.8648C9.5645 14.7825 10.1205 14.6305 10.6548 14.4091C12.1375 13.795 13.3615 12.6856 14.1181 11.2702C14.8746 9.85473 15.117 8.22074 14.8039 6.64662C14.4908 5.0725 13.6416 3.65564 12.4009 2.63746C11.4203 1.83265 10.243 1.31629 9 1.13523V1.07178C9.25304 1.1083 9.5034 1.1586 9.74999 1.22227C10.7289 1.47505 11.6484 1.93869 12.4408 2.58893C13.6926 3.61632 14.5496 5.046 14.8655 6.63437C15.1814 8.22274 14.9369 9.87152 14.1734 11.2998C13.41 12.728 12.175 13.8474 10.6788 14.4672C10.3753 14.5929 10.0649 14.6964 9.75 14.7777C9.50244 14.8417 9.25206 14.8918 9 14.9282Z",
    fill: "white",
    stroke: "url(#paint1_linear_1993_5227)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1993_5227",
    x1: 3.00001,
    y1: 15.9995,
    x2: 3,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B59F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1993_5227",
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBDAA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLoader);
export default __webpack_public_path__ + "static/media/DocLoader.48f7a26b236f275e044b0a39b0484fbe.svg";
export { ForwardRef as ReactComponent };